import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Events from './pages/Events';
import PhotoGallery from './pages/PhotoGallery';
import RSVP from './pages/RSVP';
import Hotels from './pages/Hotels';
import QandA from './pages/QandA';
import Registry from './pages/Registry';
import EngagementPhotos from './pages/EngagementPhotos';
import ChinaPhotos from './pages/ChinaPhotos'
import PortraitLoungePhotos from './pages/PortraitLoungePhotos';
import VietnamPhotos from './pages/VietnamPhotos'
import AllPhotos from './pages/AllPhotos'
import Admin from './pages/Admin'
import NotFound from './pages/NotFound';

function AnimatedRoutes() {
  const location = useLocation()

  return (
    <>
      {/* <AnimatePresence mode="wait"> */}
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Navigate to="/home" replace />} />
        <Route path="/home" element={<Home />} />
        <Route path="/events" element={<Events />} />
        <Route path="/rsvp/*" element={<RSVP />} />
        <Route path="/gallery" element={<PhotoGallery />} />
        <Route path="/gallery/portrait-lounge" element={<PortraitLoungePhotos />} />
        <Route path="/gallery/china-pre-wedding" element={<ChinaPhotos />} />
        <Route path="/gallery/vietnam-pre-wedding" element={<VietnamPhotos />} />
        <Route path="/gallery/engagement-shoot" element={<EngagementPhotos />} />
        <Route path="/hotels" element={<Hotels />} />
        <Route path="/qa" element={<QandA />} />
        <Route path="/registry" element={<Registry />} />
        <Route path="/allphotos" element={<AllPhotos />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<NotFound />} />

        {/* <Route path="/" element={<Navigate to="/rsvp" replace />} />
        <Route path="/home" element={<PageFade><Home /></PageFade>} />
        <Route path="/events" element={<PageFade><Events /></PageFade>} />
        <Route path="/rsvp/*" element={<PageFade><RSVP/></PageFade>} />
        <Route path="/gallery" element={<PageFade><PhotoGallery /></PageFade>} />
        <Route path="/gallery/china-pre-wedding" element={<PageFade><ChinaPhotos /></PageFade>} />
        <Route path="/gallery/vietnam-pre-wedding" element={<PageFade><VietnamPhotos /></PageFade>} />
        <Route path="/gallery/engagement-shoot" element={<PageFade><EngagementPhotos /></PageFade>} />
        <Route path="/hotels" element={<PageFade><Hotels /></PageFade>} />
        <Route path="/qa" element={<PageFade><QandA /></PageFade>} />
        <Route path="/registry" element={<PageFade><Registry /></PageFade>} />
        <Route path="/allphotos" element={<PageFade><AllPhotos /></PageFade>} />
        <Route path="/admin" element={<PageFade><Admin /></PageFade>} />
        <Route path="*" element={<PageFade><NotFound /></PageFade>} /> */}
      </Routes>
      {/* </AnimatePresence > */}
    </>
  )
}

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <AnimatedRoutes />
    </BrowserRouter>
  )
}
